<template>
	<div class="young-index" :style="{height: height}">
		<div class="account" @click="toAccount">

		</div>
		<div class="to-zh" @click="changeLang('zh')">

		</div>
		<div class="to-en" @click="changeLang('en')">

		</div>

		<div class="qwxzs" @click="toPath('qwzs')">

		</div>
		<div class="xxhj" @click="toPath('xxhj')">

		</div>
		<div class="kpxjt" @click="toPath('kpxjt')">

		</div>
		<div class="zyzs" @click="toPath('zyzs')">

		</div>
		<div class="hdyx" @click="toPath('hdyx')">

		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				default_title_list_start: [
					{
						name: "首页",
						children: [],
						path: "/home"
					}
				],
				en_default_title_list_start: [
					{
						name: "Home",
						children: [],
						path: "/en_home"
					}
				],
				height: '843px',
				defalut_title_list_end: [
					// {
					// 	name: "参观留言",
					// 	children: [],
					// 	path: "/jslt"
					// }
				]
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = false
			this.getTree()
			this.changeMargin();
			//监听浏览器宽度的改变
			window.onresize = () => {
				this.changeMargin()
			};
		},

		methods: {
			changeMargin() {
				//获取网页可见区域宽度
				var docWidth = document.body.clientWidth;
				if(docWidth > 1500) {
					this.height = (docWidth * 0.56) + 'px'
				} else {
					this.height = '843px'
				}
			},
			getTree() {
				let that = this
				that.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: 2
					}
				}).then(res => {
					that.$store.state.youngTitleList = res.data
				})
			},
			toAccount() {
				let that = this
				var titleList = []
				that.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: 1
					}
				}).then(res => {
					var titleList = []
					if(res.code === 'S200') {
						titleList.push(...that.default_title_list_start)
						titleList.push(...res.data)
						titleList.push(...that.defalut_title_list_end)
					}
					that.$store.state.titleList = titleList
					that.$store.state.lang = 'zh'
					that.$store.state.firstSelect = ''
					that.$store.state.secondSelect = ''
					that.$router.push('grxx')
				})
			},
			changeLang(lang) {
				let that = this
				that.$store.state.lang = lang
				that.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: lang === 'zh' ? 1 : 3
					}
				}).then(res => {
					var titleList = []
					if(res.code === 'S200') {
						if(lang === 'zh') {
							titleList.push(...that.default_title_list_start)
							titleList.push(...res.data)
							titleList.push(...that.defalut_title_list_end)
							that.$store.state.titleList = titleList
							that.$router.push('/home')
						} else {
							titleList.push(...that.en_default_title_list_start)
							titleList.push(...res.data)
							that.$store.state.titleList = titleList
							that.$router.push('/en_home')
						}
					}
				})
			},
			toPath(url) {
				if(url == 'xxhj') {
					this.$Message.info('尚未开放，敬请期待！')
					return
				}
				this.$router.push(url)
			}
		}
	}
</script>

<style lang="less" scoped>
	.young-index {
		width: 100%;
		background-image: url(../../../static/young_index.png);
		background-size: 100% 100%;
		position: relative;
		.account {
			position: absolute;
			top: 1.2%;
			left: 41%;
			width: 6%;
			height: 4%;
			cursor: pointer;
		}
		.to-zh {
			position: absolute;
			top: 1.2%;
			left: 50.5%;
			width: 3%;
			height: 4%;
			cursor: pointer;
		}
		.to-en {
			position: absolute;
			top: 1.2%;
			left: 54%;
			width: 4.4%;
			height: 4%;
			cursor: pointer;
		}
		.qwxzs {
			position: absolute;
			bottom: 5%;
			left: 7%;
			height: 10%;
			width: 17%;
			cursor: pointer;
		}
		.xxhj {
			position: absolute;
			bottom: 5%;
			left: 25.6%;
			height: 10%;
			width: 14%;
			cursor: pointer;
		}
		.kpxjt {
			position: absolute;
			bottom: 5%;
			left: 43.5%;
			height: 10%;
			width: 15%;
			cursor: pointer;
		}
		.zyzs {
			position: absolute;
			bottom: 5%;
			left: 61.6%;
			height: 10%;
			width: 13%;
			cursor: pointer;
		}
		.hdyx {
			position: absolute;
			bottom: 5%;
			left: 80%;
			height: 10%;
			width: 14%;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/young/index.vue